import { useState } from "react";
import { DialogContentText, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import SimpleDialog from "components/SimpleDialog";
import MoveIcon from "@mui/icons-material/SwapHoriz";
import { Order } from "models/Order";
import { Product } from "models/Product";
import { useMoveOrderSerialMutation, useMoveSerialEntityMutation } from "app/api/checklists";
import { toast } from "react-toastify";

type MoveProductDialogProps = {
  product: Product;
  checklistId: string;
  order: Order;
  onClose: () => void;
};

const MoveProductDialog: React.FC<MoveProductDialogProps> = (props) => {
  const { product, checklistId, order, onClose } = props;
  const [selectedChecklistId, setSelectedChecklistId] = useState<string | null>(null);

  const [moveOrderSerial, { isLoading: isMovingOrderSerial }] = useMoveOrderSerialMutation();
  const [moveSerialEntity, { isLoading: isMovingSerialEntity }] = useMoveSerialEntityMutation();

  return (
    <SimpleDialog
      title="Flytta produkt?"
      confirmProps={{
        children: "Flytta",
        color: "warning",
        startIcon: <MoveIcon />,
        disabled: !selectedChecklistId,
      }}
      loading={isMovingOrderSerial || isMovingSerialEntity}
      onClose={onClose}
      onConfirm={async () => {
        if (!selectedChecklistId) throw new Error("No target checklist selected");

        const request = {
          serialId: product.id,
          originalChecklistId: checklistId,
          targetChecklistId: selectedChecklistId,
          orderId: order.ordernr,
        };

        try {
          if (product.existing) {
            await moveSerialEntity(request).unwrap();
          } else {
            await moveOrderSerial(request).unwrap();
          }
        } catch (error) {
          toast.error("Kunde inte flytta produkten");
          console.error("Error moving product:", error);
        }
        onClose();
      }}
    >
      <DialogContentText sx={{ mb: 2 }}>
        Produkten kan flyttas till en annan checklista i samma order.
      </DialogContentText>

      <FormControl variant="filled" fullWidth>
        <InputLabel>Välj checklista</InputLabel>
        <Select
          value={selectedChecklistId || ""}
          onChange={(e) => setSelectedChecklistId(e.target.value)}
        >
          {order.checklists
            ?.filter((c) => c.id !== checklistId)
            .map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.roomName}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </SimpleDialog>
  );
};

export default MoveProductDialog;
